// ConverMax inject scripts for Defiant Wheels
// Hook YMM clear buttons to also clear ConverMax facet filters
(function() {
  document.addEventListener('click', function(e) {
    // "Clear All" button in sidebar filter
    if (e.target.closest('.clear-all-btn')) {
      if (window.Convermax && window.Convermax.clearCurrentRequest) {
        window.Convermax.clearCurrentRequest(true); // true = preserve vehicle selection
      }
    }
    // YMM "CLEAR" button in the ConverMax vehicle widget bar
    if (e.target.closest('.cm_vehicle-widget_button__clear')) {
      if (window.Convermax && window.Convermax.clearCurrentRequest) {
        window.Convermax.clearCurrentRequest(false); // false = clear everything including vehicle
      }
      // Defiant-specific: clearCurrentRequest(false) doesn't reliably trigger the nav-API
      // interceptor on PDPs, so the storage wipe + banner re-render must run inline here.
      // Also sets ymmUserCleared flag because Convermax.api.getActiveVehicle is NOT reset
      // by clearCurrentRequest, and product-fitment-banner.js falls back to it; without
      // the flag the banner resurrects the just-cleared vehicle.
      try {
        localStorage.removeItem('ymm-year');
        localStorage.removeItem('ymm-make');
        localStorage.removeItem('ymm-model');
        localStorage.removeItem('cm_variant-model');
        localStorage.removeItem('cm_variant-garage');
        sessionStorage.removeItem('cm_vehicle');
        sessionStorage.setItem('ymmUserCleared', '1');
      } catch (err) {}
      window.dispatchEvent(new CustomEvent('ymmUpdated', { detail: null }));
      window.dispatchEvent(new CustomEvent('fitment:refresh'));
    }
  });
})();

/* ---------------------------------------------------------------------------
 * Notion #404 — Availability filter default-unchecked shim
 * Convermax dashboard pre-selects "Available" on the cm_field-stock facet,
 * which hides ~1330 OOS products by default. We can't deselect "Available"
 * directly (Convermax canonicalizes ?stock/Available to base URL since it
 * matches the default), so on collection-page load with no user-picked stock
 * value we programmatically click the "All" row to switch into the
 * show-everything state (URL gains ?stock/All, count = full inventory).
 *
 * The hidden "In-stock Only" + "All" rows are masked by CSS in
 * convermax-custom.css; only the "Available" row is visible, relabeled to
 * "In Stock". Once "All" is selected, that visible row appears unchecked
 * (no .selected class) — matching the unchecked-by-default UX intent.
 *
 * We also intercept clicks on the visible row when it is already selected
 * (the "uncheck" gesture) and re-route them to the "All" row, since clicking
 * a selected default-equivalent value in Convermax is a no-op.
 *
 * Finally we hide the "All" / "Available" / "In-stock Only" chips that
 * Convermax otherwise renders in the active-filter strip — the visible
 * checkbox is the single source of truth for stock-filter state.
 * ------------------------------------------------------------------------- */
(function () {
  var SS_KEY = 'oew_stock_user_picked';
  var STOCK_VALUES = ['All', 'Available', 'In-stock Only'];
  // A link that lands here with a stock value (e.g. the PDP packages "View All" -> ?.../stock/Available)
  // is an explicit pick. Convermax canonicalizes the default value out of the URL before this shim
  // runs again, so remember it from the landing URL for this page view.
  var LANDED_WITH_STOCK = /[?&\/]stock\//.test(location.pathname + location.search);
  function isCollectionPage() {
    // Pages where Convermax renders facets/results and where the default
    // stock-filter state should be unchecked (Notion #404).
    // - /collections/* : canonical collection pages
    // - /pages/search  : destination of the homepage YMM widget submit
    return location.pathname.indexOf('/collections/') === 0
        || location.pathname === '/pages/search';
  }
  function urlHasStock() {
    return /[?&\/]stock\//.test(location.pathname + location.search);
  }
  function userPickedStock() {
    if (urlHasStock()) return true;
    try { return sessionStorage.getItem(SS_KEY) === '1'; } catch (e) { return false; }
  }
  function markUserPicked() {
    try { sessionStorage.setItem(SS_KEY, '1'); } catch (e) {}
  }
  function ensureAllSelected() {
    if (!isCollectionPage()) return;
    if (urlHasStock() || LANDED_WITH_STOCK) return; // explicit stock value in the URL
    if (userPickedStock()) return;        // user-CHECK in this session canonicalized URL → leave alone
    var facet = document.querySelector('.facetholder.cm_field-stock');
    if (!facet) return;
    var allKey = null;
    var keys = facet.querySelectorAll('.facetentrykey');
    for (var i = 0; i < keys.length; i++) {
      if ((keys[i].textContent || '').trim() === 'All') { allKey = keys[i]; break; }
    }
    if (!allKey) return;
    var selected = facet.querySelector('.facetdiv.selected .facetentrykey');
    var selTxt = selected ? (selected.textContent || '').trim() : '';
    if (selTxt === 'All') return;         // already in the desired state
    allKey.click();                        // switch into ?stock/All
  }
  function hideStockChips() {
    // The site's CSS uses `display: flex !important` for chip rows, so we
    // must set !important on our hide to win the cascade.
    var chips = document.querySelectorAll('.cm_FilterChips .facetdiv.cmTemplate_chip, .cm_filterChips .facetdiv.cmTemplate_chip');
    chips.forEach(function (c) {
      var key = c.querySelector('.facetentrykey');
      if (!key) return;
      var txt = (key.textContent || '').trim();
      if (STOCK_VALUES.indexOf(txt) !== -1) {
        c.style.setProperty('display', 'none', 'important');
      }
    });
  }
  function applyAll() {
    ensureAllSelected();
    hideStockChips();
  }
  // Hijack clicks on the visible row 2 ("Available", relabeled "In Stock"):
  //  - If row 2 is unselected → user is "checking" → let Convermax select it
  //    (URL gets canonicalized to base, but "Available" selected internally,
  //    count drops to in-stock).
  //  - If row 2 is selected → user is "unchecking" → Convermax otherwise
  //    treats that as a no-op, so we cancel and click row 3 ("All") instead.
  document.addEventListener('click', function (e) {
    var hit = e.target.closest && e.target.closest('.facetholder.cm_field-stock .facetdiv');
    if (!hit) return;
    // Only mark "user picked" on clicks against the visible row (:nth-child(2)).
    // Rows 1 and 3 are hidden via CSS, so the only way they get clicked is
    // programmatically (the shim clicking "All", or this intercept re-routing
    // an uncheck). We must not let those programmatic clicks pin the flag,
    // because the flag persists across same-origin navigations and would
    // disable the shim on subsequent visits.
    if (!hit.matches(':nth-child(2)')) return;
    markUserPicked();
    if (hit.classList.contains('selected')) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      var allRow = document.querySelector('.facetholder.cm_field-stock .facetdiv:nth-child(3) .facetentrykey');
      if (allRow) allRow.click();
    }
  }, true);
  // Re-apply chip-hide on Convermax DOM updates. ensureAllSelected is also
  // called here, but its userPickedStock guard prevents looping with the
  // user-CHECK transition.
  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; applyAll(); });
  }
  function startObserver() {
    if (!document.body) return;
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    applyAll();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver);
  } else {
    startObserver();
  }
})();


// === Sale Custom Label Injection on Convermax tiles — Notion #412 ===
// Reads product.metafields.oew.{sale_custom_label, b2b_custom_label, on_sale, on_sale_b2b}
// via the /search?section_id=sale-label-data endpoint and injects SALE label badges into
// .cm_product-item / .product-card tiles gated by shop-level + per-product + customer-type rules.

// Inject scoped styles for .cm-sale-label so the shim badges render with the same red-badge
// styling as legacy .label-sale (2026-05-20 follow-up fix — see Notion #412).
(function injectCmSaleLabelStyles() {
  if (document.getElementById('cm-sale-label-styles')) return;
  var style = document.createElement('style');
  style.id = 'cm-sale-label-styles';
  style.textContent = '.cm-sale-label { display:block; background:var(--hight-color,#D2190B); color:#fff; padding:4px 8px; font-size:14px; font-weight:700; line-height:21px; border-radius:0; text-transform:uppercase; letter-spacing:normal; }';
  document.head.appendChild(style);
})();

(function() {
  var saleLabelCache = {}; // keyed by handle
  var pendingFetches = {};

  function readBodyAttr(name) {
    return document.body ? document.body.getAttribute(name) : null;
  }
  function isRetailEnabled() { return readBodyAttr('data-retail-sale-enabled') === 'true'; }
  function isB2BEnabled()    { return readBodyAttr('data-b2b-sale-enabled')    === 'true'; }
  function isCustomerB2B()   { return readBodyAttr('data-customer-b2b')        === 'true'; }

  function chooseLabelText(data) {
    if (!data) return null;
    if (isCustomerB2B()) {
      if (isB2BEnabled() && data.b2bLabel && data.onSaleB2B === 'Included') {
        return data.b2bLabel;
      }
      return null;
    }
    if (isRetailEnabled() && data.retailLabel && data.onSale === 'Included') {
      return data.retailLabel;
    }
    return null;
  }

  function applySaleLabel(card, data) {
    var labelText = chooseLabelText(data);
    if (!labelText) return;
    // De-dup
    if (card.querySelector('.cm-sale-label')) return;

    // Find or create label group container (anchored inside the media area)
    var labelGroup = card.querySelector('.label-group');
    if (!labelGroup) {
      var mediaEl =
        card.querySelector('.cm_product-item__media') ||
        card.querySelector('.product-media') ||
        card.querySelector('.cm_product-item__image-container') ||
        card.querySelector('.cm_product-item__image');
      if (!mediaEl) return;
      if (getComputedStyle(mediaEl).position === 'static') {
        mediaEl.style.position = 'relative';
      }
      labelGroup = document.createElement('div');
      labelGroup.className = 'label-group cm-sale-label-group';
      labelGroup.style.cssText = 'position:absolute;top:0;left:0;display:flex;flex-direction:column;gap:4px;z-index:5;pointer-events:none;';
      mediaEl.appendChild(labelGroup);
    }

    var span = document.createElement('span');
    span.className = 'label label-sale cm-sale-label';
    span.textContent = labelText;
    labelGroup.appendChild(span);
  }

  function getHandleFromCard(card) {
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return null;
    var m = link.getAttribute('href').match(/\/products\/([^?#]+)/);
    return m ? m[1] : null;
  }

  function enrichSaleLabels() {
    // Bail early if neither gate can ever fire (saves a fetch)
    if (!isRetailEnabled() && !isB2BEnabled()) return;

    // Permissive selector (Defiant shim has no UPC injection to set data-cm-enriched).
    // Dedup is handled solely by data-sale-label-enriched.
    var cards = document.querySelectorAll(
      '.product-card:not([data-sale-label-enriched]),' +
      '.cm_product-item:not([data-sale-label-enriched])'
    );
    if (!cards.length) return;

    var cardsByHandle = {};
    cards.forEach(function(card) {
      // NOTE: do NOT mark "pending" here. If Convermax has not populated this card's
      // product id in its search response yet (race during initial page load), we would
      // mark the card "pending" without ever launching a fetch — and the
      // `:not([data-sale-label-enriched])` selector above prevents future shim runs
      // from re-processing it. Causes stuck cards (2026-05-20 incident).
      // Dedup is handled by saleLabelCache (per-handle) and pendingFetches
      // (per-query). We mark "done" only after applying or skipping with confirmed data.
      var handle = getHandleFromCard(card);
      if (!handle) return;
      (cardsByHandle[handle] = cardsByHandle[handle] || []).push(card);
    });

    // Apply cached data first
    var uncachedHandles = [];
    Object.keys(cardsByHandle).forEach(function(handle) {
      if (saleLabelCache[handle]) {
        cardsByHandle[handle].forEach(function(card) {
          applySaleLabel(card, saleLabelCache[handle]);
          card.setAttribute('data-sale-label-enriched', 'done');
        });
      } else {
        uncachedHandles.push(handle);
      }
    });
    if (!uncachedHandles.length) return;

    // Map handles → product IDs via Convermax response (same pattern as B2B inventory)
    var cmResp = window.Convermax && window.Convermax.getSearchResponse && window.Convermax.getSearchResponse();
    var idsToFetch = [];
    if (cmResp && cmResp.items && cmResp.items._items) {
      cmResp.items._items.forEach(function(item) {
        if (!item._item) return;
        var h = item._item.handle;
        var id = item._item.id;
        if (h && id && uncachedHandles.indexOf(h) !== -1) {
          idsToFetch.push(id);
        }
      });
    }
    if (!idsToFetch.length) return;

    var batchSize = 20;
    for (var i = 0; i < idsToFetch.length; i += batchSize) {
      var batch = idsToFetch.slice(i, i + batchSize);
      var query = batch.map(function(id) { return 'id:' + id; }).join(' OR ');
      if (pendingFetches[query]) continue;
      pendingFetches[query] = true;

      (function(q, byHandle) {
        fetch('/search?section_id=sale-label-data&q=' + encodeURIComponent(q) + '&type=product')
          .then(function(r) { return r.text(); })
          .then(function(html) {
            delete pendingFetches[q];
            var m = html.match(/\[[\s\S]*\]/);
            if (!m) return;
            var data;
            try { data = JSON.parse(m[0]); } catch (e) { return; }
            data.forEach(function(product) {
              if (!product || !product.handle) return;
              saleLabelCache[product.handle] = product;
              var cardsForHandle = byHandle[product.handle];
              if (cardsForHandle) {
                cardsForHandle.forEach(function(card) {
                  applySaleLabel(card, product);
                  card.setAttribute('data-sale-label-enriched', 'done');
                });
              }
            });
          })
          .catch(function(err) {
            delete pendingFetches[q];
            console.warn('[sale-label] fetch error:', err);
          });
      })(query, cardsByHandle);
    }
  }

  // Self-trigger on Defiant (no processCards() in this theme's shim to hook into).
  // Pattern modeled on the Notion #404 availability shim earlier in this file:
  // MutationObserver + DOMContentLoaded + a couple of timed re-runs to catch
  // late-arriving Convermax tile renders.
  var __sl_pending = false;
  function __sl_schedule() {
    if (__sl_pending) return;
    __sl_pending = true;
    requestAnimationFrame(function() { __sl_pending = false; enrichSaleLabels(); });
  }
  function __sl_start() {
    if (!document.body) return;
    new MutationObserver(__sl_schedule).observe(document.body, { childList: true, subtree: true });
    setTimeout(enrichSaleLabels, 500);
    setTimeout(enrichSaleLabels, 1500);
    setTimeout(enrichSaleLabels, 3000);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', __sl_start);
  } else {
    __sl_start();
  }

  // Also expose for any future shim that wants to trigger directly
  window.__saleLabelEnrich = enrichSaleLabels;
})();


/* ============================================================
   PDP-STAY interceptor — ported from OEW (commit 807be95). Keeps the customer on the PDP
   when the Shop-by-Vehicle bar changes YMM (Defiant bar navigates to /pages/search like OEW),
   instead of redirecting. Fitment re-evaluates via product-form.js (ymmUpdated/fitment:refresh).
   Added to Defiant 2026-05-26.
   ============================================================ */
// On PDP pages, intercept the navigation that Convermax triggers when the Shop By Vehicle
// header widget reaches a complete Year/Make/Model selection. Default behaviour is to
// navigate to /pages/search?Year/.../Make/.../Model/... which loads a collection results
// page — we want the customer to stay on the current PDP and just have the fitment gate
// re-evaluate. Uses the Navigation API (window.navigation) available in modern Chrome.
// Collection and search pages keep Convermax's default behaviour.
(function() {
  const onPDP = () => document.body && document.body.classList.contains('template-product');

  // Parse Convermax's search URL format: /pages/search?Year/2015/Make/Chevrolet/Model/Silverado-1500
  const parseCmSearchUrl = (url) => {
    try {
      const u = new URL(url, window.location.href);
      if (!u.pathname.startsWith('/pages/search')) return null;
      // Convermax uses `/` as the separator inside the query string instead of `&`.
      // Query starts after `?`. Example raw: "Year/2015/Make/Chevrolet/Model/Silverado-1500"
      const raw = u.search.replace(/^\?/, '');
      if (!raw) return null;
      const parts = raw.split('/').map(decodeURIComponent);
      const out = {};
      for (let i = 0; i + 1 < parts.length; i += 2) {
        out[parts[i]] = parts[i + 1];
      }
      if (out.Year && out.Make && out.Model) return out;
      return null;
    } catch (e) { return null; }
  };

  const updateFitmentState = (ymm) => {
    try {
      // localStorage ymm-* — read by the mobile YMM bar and the OEW-style top banner.
      localStorage.setItem('ymm-year', ymm.Year);
      localStorage.setItem('ymm-make', ymm.Make);
      localStorage.setItem('ymm-model', ymm.Model);
      // sessionStorage cm_vehicle — read by product-fitment-banner.js.
      sessionStorage.setItem('cm_vehicle', JSON.stringify({ year: String(ymm.Year), make: String(ymm.Make), model: String(ymm.Model) }));
      // Drop the user-cleared flag so the banner can render the new vehicle.
      sessionStorage.removeItem('ymmUserCleared');
    } catch (err) {}
    window.dispatchEvent(new CustomEvent('ymmUpdated', { detail: { year: ymm.Year, make: ymm.Make, model: ymm.Model } }));
    window.dispatchEvent(new CustomEvent('fitment:refresh'));
  };

  // Track recent Convermax widget interactions so the Navigation API handler can distinguish
  // widget-driven navigations (which we intercept on PDP) from legitimate nav-to-search flows
  // (e.g. typing in the search box, clicking SHOP BY VEHICLE in the main nav).
  let recentWidgetInteractionAt = 0;
  const markWidgetInteraction = () => { recentWidgetInteractionAt = Date.now(); };
  document.addEventListener('click', function(e) {
    if (e.target.closest('.cm_vehicle-widget')) markWidgetInteraction();
  }, true);
  document.addEventListener('change', function(e) {
    if (e.target && e.target.closest && e.target.closest('.cm_vehicle-widget')) markWidgetInteraction();
  }, true);
  const isRecentWidgetInteraction = () => (Date.now() - recentWidgetInteractionAt) < 1500;
  // Bridge for the mobile bar's × Clear (in the bar IIFE, which is a separate
  // closure). The bar sets window.__ymmBarClearedAt right before triggering
  // Convermax.clearCurrentRequest(false); honor that as a "recent widget clear"
  // so the navigation interceptor below cancels the /pages/search redirect on
  // PDP. Same 1.5s window as widget clicks.
  const isRecentBarClear = () => (Date.now() - (window.__ymmBarClearedAt || 0)) < 1500;

  // Escape hatch: when the customer clicks an allow-listed link below, programmatic
  // widget-driven navigation should be allowed to proceed without interception.
  let allowNextNavigationUntil = 0;
  const allowNextNavigationFor = (ms) => { allowNextNavigationUntil = Date.now() + ms; };
  const isNavigationAllowed = () => Date.now() < allowNextNavigationUntil;

  // "Shop wheels that fit" link handling. The link's default handler in
  // product-fitment-banner.js programmatically populates Convermax's Y/M/M dropdowns and
  // clicks the SHOP button — but Convermax silently refuses to navigate when the chosen
  // vehicle has no products matching the current product's type. Result: spinner then
  // back to the PDP. Bypass Convermax and navigate directly to the vehicle-filtered
  // collection URL using Convermax's own URL format.
  document.addEventListener('click', function(e) {
    const link = e.target.closest('.shop-wheels-fit-link');
    if (!link) return;
    // Block the banner's own handler and the anchor default
    e.preventDefault();
    e.stopImmediatePropagation();
    e.stopPropagation();

    const year  = localStorage.getItem('ymm-year');
    const make  = localStorage.getItem('ymm-make');
    const model = localStorage.getItem('ymm-model');
    if (!year || !make || !model) return;
    // Convermax search-URL format: /pages/search?Year/<y>/Make/<m>/Model/<mo>  (slash-
    // separated key/value pairs inside the query; spaces -> %20 via encodeURIComponent)
    const searchUrl = '/pages/search?Year/' + encodeURIComponent(year)
      + '/Make/' + encodeURIComponent(make)
      + '/Model/' + encodeURIComponent(model);
    // Ensure our PDP Navigation API interceptor doesn't cancel this — allow window of a
    // few seconds is cheap insurance.
    allowNextNavigationFor(3000);
    window.location.href = searchUrl;
  }, true);

  // Primary mechanism: Navigation API (Chrome 102+). Lets us cancel any navigation.
  if (window.navigation && typeof window.navigation.addEventListener === 'function') {
    window.navigation.addEventListener('navigate', function(e) {
      if (!onPDP()) return;
      if (!e.destination || !e.destination.url) return;
      // Escape hatch: a recent click on an allow-listed control (e.g. "shop wheels that fit")
      // should be allowed to navigate through to the collection/search page.
      if (isNavigationAllowed()) return;
      let dest;
      try { dest = new URL(e.destination.url); } catch (err) { return; }
      // Only intercept same-origin navigations heading to Convermax's search pattern
      if (dest.origin !== window.location.origin) return;
      if (!dest.pathname.startsWith('/pages/search')) return;

      const ymm = parseCmSearchUrl(e.destination.url);
      if (ymm) {
        // SELECT/CHANGE case — widget produced a full YMM URL
        if (typeof e.preventDefault === 'function') e.preventDefault();
        if (typeof e.intercept === 'function') { try { e.intercept({ handler: async () => {} }); } catch (err) {} }
        updateFitmentState(ymm);
        return;
      }
      // CLEAR case — bare /pages/search produced by widget clear (or the mobile bar's
      // × Clear, which signals via window.__ymmBarClearedAt). Only intercept if the
      // nav was kicked off from a vehicle UI control — avoids breaking legitimate
      // searches the customer typed.
      if (isRecentWidgetInteraction() || isRecentBarClear()) {
        if (typeof e.preventDefault === 'function') e.preventDefault();
        if (typeof e.intercept === 'function') { try { e.intercept({ handler: async () => {} }); } catch (err) {} }
        try {
          localStorage.removeItem('ymm-year');
          localStorage.removeItem('ymm-make');
          localStorage.removeItem('ymm-model');
          // Also wipe Convermax's and the top-banner's own caches so stale vehicle data
          // doesn't resurface in the "This product fits your …" banner.
          localStorage.removeItem('cm_variant-model');
          localStorage.removeItem('cm_variant-garage');
          sessionStorage.removeItem('cm_vehicle');
        } catch (err) {}
        window.dispatchEvent(new CustomEvent('ymmUpdated', { detail: null }));
        window.dispatchEvent(new CustomEvent('fitment:refresh'));
      }
    });
  }

  // Fallback: also hook the SHOP button click (capture phase) for browsers without the
  // Navigation API. On those browsers this fallback is best-effort; Convermax may still
  // fire its own change-event-driven navigation before we can intercept.
  document.addEventListener('click', function(e) {
    const goBtn = e.target.closest('.cm_vehicle-widget_button__go');
    if (!goBtn) return;
    if (!onPDP()) return;
    const ymmRoot = goBtn.closest('.cm_vehicle-widget') || document;
    const yearEl  = ymmRoot.querySelector('.cm_select_inner-select[aria-label="Year"]');
    const makeEl  = ymmRoot.querySelector('.cm_select_inner-select[aria-label="Make"]');
    const modelEl = ymmRoot.querySelector('.cm_select_inner-select[aria-label="Model"]');
    const year  = yearEl  && yearEl.value;
    const make  = makeEl  && makeEl.value;
    const model = modelEl && modelEl.value;
    if (!year || !make || !model) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    e.stopPropagation();
    updateFitmentState({ Year: year, Make: make, Model: model });
  }, true);
})();


/* ============================================================
   HOME / NON-PDP YMM -> COLLECTION redirect (#401 parity with 4PLAY/OEW).
   4PLAY & OEW have Convermax "Vehicle Landing Pages" enabled, so selecting a
   vehicle lands on a per-vehicle /collections/<year-make-model> page. Defiant
   does NOT have those collections (they 404), so Convermax falls back to
   /pages/search — a worse, search-flavored landing. The per-vehicle collections
   are Convermax-generated and can't be created from the theme, so the closest
   faithful mimic is to send vehicle-only selections to /collections/all with the
   same vehicle facet (Convermax then fitment-filters it). Free-text searches
   (?.../query/...) are left on /pages/search. PDP is handled by the PDP-stay
   interceptor above, so we skip it here. Added 2026-06-30.
   ============================================================ */
(function() {
  const onPDP = () => document.body && document.body.classList.contains('template-product');

  // Parse Convermax's slash-delimited search query. Returns the raw facet string
  // when it is a COMPLETE Year/Make/Model selection with NO free-text query; else null.
  const vehicleOnlyFacet = (url) => {
    try {
      const u = new URL(url, window.location.href);
      if (!u.pathname.startsWith('/pages/search')) return null;
      // A free-text search is ?...&query=... (or ?q=...). Convermax keeps the vehicle as
      // a slash-facet and appends the text query as a standard &param, e.g.
      // /pages/search?Year/2023/Make/Acura/Model/MDX&query=wheels — so detect the text
      // query via real param parsing and leave those on /pages/search.
      if (u.searchParams.get('query') || u.searchParams.get('q')) return null;
      // Convermax uses literal "/" separators in the query; some entry points percent-encode
      // them as %2F — normalize both. The vehicle facet is the slash-delimited segment
      // before any &param.
      const raw = u.search.replace(/^\?/, '').replace(/%2F/gi, '/');
      if (!raw) return null;
      const facet = raw.split('&')[0];
      const parts = facet.split('/').map(decodeURIComponent);
      const out = {};
      for (let i = 0; i + 1 < parts.length; i += 2) out[parts[i]] = parts[i + 1];
      if (out.query || out.q) return null;            // belt-and-suspenders
      if (out.Year && out.Make && out.Model) return facet;
      return null;
    } catch (e) { return null; }
  };

  const toCollection = (rawFacet) => '/collections/all?' + rawFacet;
  const go = (rawFacet) => {
    const dest = toCollection(rawFacet);
    try { window.location.replace(dest); } catch (e) { window.location.href = dest; }
  };

  // Redirect-on-arrival. Selecting a vehicle from the home page (or any non-Convermax
  // page) makes Convermax do a FULL navigation to /pages/search?Year/.../Make/.../Model/...
  // — so by the time this script runs on that page we just bounce to the equivalent
  // /collections/all facet. Runs at script-init so the search page barely paints.
  // We deliberately do NOT intercept the navigation via the Navigation API: cancelling
  // Convermax's nav and re-navigating from inside the 'navigate' handler is unreliable
  // (can strand the user on the home page), whereas this arrival check is bulletproof
  // and works in every browser (incl. Safari/iOS). PDP keeps the PDP-stay behavior;
  // text searches (?.../query/...) and already-on-collection pages are left alone.
  (function redirectOnArrival() {
    if (onPDP()) return;
    if (location.pathname.indexOf('/collections/') === 0) return;
    const facet = vehicleOnlyFacet(window.location.href);
    if (facet) go(facet);
  })();
})();


// === Custom Card Label Injection on Convermax tiles — Notion #423 ===
// Restores the pre-Convermax "Custom Card Label" badge (e.g. "Single", "Set of 4",
// "W/T Set of 4") on collection/search tiles. Reads product.metafields.oew.custom_card_label
// (metaobject: label + color) via the /search?section_id=card-label-data endpoint and injects
// a .cm-custom-label badge into .cm_product-item / .product-card tiles. No shop-level gate —
// the badge shows whenever the metaobject field is populated, hidden when empty (Notion #423 AC).
// Models the Notion #412 sale-label shim (same handle->id->fetch pattern, same race-safe dedup).

// Scoped styles for .cm-custom-label — Convermax tiles do NOT inherit the theme's
// `.product-card .product-card_header .label` rules (see reference_convermax_tile_css_scope),
// so reproduce the native .label + .label-custom computed styles here. order:2 keeps the card
// label stacked BELOW any sale badge (.cm-sale-label, default order 0) in a shared .label-group.
(function injectCmCardLabelStyles() {
  if (document.getElementById('cm-custom-label-styles')) return;
  var style = document.createElement('style');
  style.id = 'cm-custom-label-styles';
  style.textContent = '.cm-custom-label { display:block; width:fit-content; background:var(--background-label,#4e89b7); color:var(--text-color,#fff); padding:4px 8px; font-size:14px; font-weight:700; line-height:21px; border-radius:0; text-transform:uppercase; letter-spacing:normal; order:2; }';
  document.head.appendChild(style);
})();

(function() {
  var cardLabelCache = {}; // keyed by handle -> {label,color} (or {label:null} cached miss)
  var pendingFetches = {}; // keyed by section query
  var handleIdCache = {};  // handle -> numeric Shopify product id
  var idJsPending = {};    // handles with an in-flight /products/{handle}.js id lookup

  function applyCardLabel(card, data) {
    if (!data || !data.label) return;
    // De-dup against BOTH the shim's own badge AND any native theme-rendered .label-custom
    // (product-item.liquid renders it on fully-native grids — homepage featured collections,
    // PDP related products, cart drawer — where Liquid has metaobject access. Convermax-shell
    // .product-card tiles render no native label, so the shim fills those.) Skip if either exists.
    if (card.querySelector('.label-custom')) return;

    // Reuse an existing label group (theme- or sale-shim-created) or create one in the media area
    var labelGroup = card.querySelector('.label-group');
    if (!labelGroup) {
      var mediaEl =
        card.querySelector('.cm_product-item__media') ||
        card.querySelector('.product-media') ||
        card.querySelector('.cm_product-item__image-container') ||
        card.querySelector('.cm_product-item__image');
      if (!mediaEl) return;
      if (getComputedStyle(mediaEl).position === 'static') {
        mediaEl.style.position = 'relative';
      }
      labelGroup = document.createElement('div');
      labelGroup.className = 'label-group cm-card-label-group';
      labelGroup.style.cssText = 'position:absolute;top:0;left:0;display:flex;flex-direction:column;gap:4px;z-index:5;pointer-events:none;';
      mediaEl.appendChild(labelGroup);
    }

    var span = document.createElement('span');
    span.className = 'label label-custom cm-custom-label';
    if (data.color) span.style.setProperty('--background-label', data.color);
    span.textContent = data.label;
    labelGroup.appendChild(span);
  }

  function getHandleFromCard(card) {
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return null;
    var m = link.getAttribute('href').match(/\/products\/([^?#]+)/);
    return m ? m[1] : null;
  }

  function enrichCardLabels() {
    var cards = document.querySelectorAll(
      '.product-card:not([data-card-label-enriched]),' +
      '.cm_product-item:not([data-card-label-enriched])'
    );
    if (!cards.length) return;

    var cardsByHandle = {};
    cards.forEach(function(card) {
      // Short-circuit: if this tile already shows a custom label (native product-item.liquid
      // render on fully-native grids — homepage featured collections, PDP related products,
      // cart drawer — where Liquid has metaobject access), the badge is already correct.
      // Mark done and skip — avoids wasted id/label lookups and any chance of a duplicate.
      if (card.querySelector('.label-custom')) {
        card.setAttribute('data-card-label-enriched', 'done');
        return;
      }
      // Do NOT mark "pending" here — same race lesson as Notion #412: if a card's id is not
      // resolvable yet (Convermax response not ready / .js lookup in flight), marking it would
      // orphan the card (the :not([data-card-label-enriched]) selector would skip it forever).
      // Mark "done" only after data is applied. Dedup via cardLabelCache + pendingFetches.
      var handle = getHandleFromCard(card);
      if (!handle) return;
      (cardsByHandle[handle] = cardsByHandle[handle] || []).push(card);
    });

    // Apply cached data first
    var uncachedHandles = [];
    Object.keys(cardsByHandle).forEach(function(handle) {
      if (cardLabelCache.hasOwnProperty(handle)) {
        cardsByHandle[handle].forEach(function(card) {
          applyCardLabel(card, cardLabelCache[handle]);
          card.setAttribute('data-card-label-enriched', 'done');
        });
      } else {
        uncachedHandles.push(handle);
      }
    });
    if (!uncachedHandles.length) return;

    // Resolve handles → numeric product IDs.
    // Fast path: the Convermax search response (collection / PLP — no network).
    var cmResp = window.Convermax && window.Convermax.getSearchResponse && window.Convermax.getSearchResponse();
    if (cmResp && cmResp.items && cmResp.items._items) {
      cmResp.items._items.forEach(function(item) {
        if (item._item && item._item.handle && item._item.id) {
          handleIdCache[item._item.handle] = item._item.id;
        }
      });
    }
    // Fallback: /products/{handle}.js (native search results + any non-Convermax product grid,
    // where getSearchResponse()._items is empty). The .js payload includes the numeric id.
    // Fires once per handle; on resolution it re-schedules the shim, which then batch-fetches
    // the label. Browser HTTP-caches .js (the tile UPC/stock enrichment fetches it too).
    var idsToFetch = [];
    uncachedHandles.forEach(function(h) {
      if (handleIdCache[h]) {
        idsToFetch.push(handleIdCache[h]);
      } else if (!idJsPending[h]) {
        idJsPending[h] = true;
        fetch('/products/' + h + '.js')
          .then(function(r) { return r.json(); })
          .then(function(d) {
            delete idJsPending[h];
            if (d && d.id) { handleIdCache[h] = d.id; __cl_schedule(); }
          })
          .catch(function() { delete idJsPending[h]; });
      }
    });
    if (!idsToFetch.length) return;

    var batchSize = 20;
    for (var i = 0; i < idsToFetch.length; i += batchSize) {
      var batch = idsToFetch.slice(i, i + batchSize);
      var query = batch.map(function(id) { return 'id:' + id; }).join(' OR ');
      if (pendingFetches[query]) continue;
      pendingFetches[query] = true;

      (function(q, byHandle) {
        fetch('/search?section_id=card-label-data&q=' + encodeURIComponent(q) + '&type=product')
          .then(function(r) { return r.text(); })
          .then(function(html) {
            delete pendingFetches[q];
            var m = html.match(/\[[\s\S]*\]/);
            if (!m) return;
            var data;
            try { data = JSON.parse(m[0]); } catch (e) { return; }
            data.forEach(function(product) {
              if (!product || !product.handle) return;
              cardLabelCache[product.handle] = product; // cache even when label is null (avoids refetch)
              var cardsForHandle = byHandle[product.handle];
              if (cardsForHandle) {
                cardsForHandle.forEach(function(card) {
                  applyCardLabel(card, product);
                  card.setAttribute('data-card-label-enriched', 'done');
                });
              }
            });
          })
          .catch(function(err) {
            delete pendingFetches[q];
            console.warn('[card-label] fetch error:', err);
          });
      })(query, cardsByHandle);
    }
  }

  // Expose so processCards() can trigger it (hook added near line 794)
  window.__cardLabelEnrich = enrichCardLabels;

  // Independent self-trigger (same robustness as the Notion #412 sale-label shim): a
  // processCards() piggyback alone stops once the DOM settles, orphaning cards whose
  // Convermax search response arrives late. MutationObserver + rAF + timed re-runs converge.
  var __cl_pending = false;
  function __cl_schedule() {
    if (__cl_pending) return;
    __cl_pending = true;
    requestAnimationFrame(function() { __cl_pending = false; enrichCardLabels(); });
  }
  function __cl_start() {
    if (!document.body) return;
    new MutationObserver(__cl_schedule).observe(document.body, { childList: true, subtree: true });
    setTimeout(enrichCardLabels, 500);
    setTimeout(enrichCardLabels, 1500);
    setTimeout(enrichCardLabels, 3000);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', __cl_start);
  } else {
    __cl_start();
  }
})();

/* ============================================================
   MOBILE YMM SELECTOR REDESIGN (Notion #401 — Defiant phase)

   Custom collapsed strip + state machine for the mobile (≤1024px)
   YMM bar. Replaces Convermax's native collapse (suppressed earlier
   in convermax-custom.css). State rules:
     - Vehicle set in localStorage → start COLLAPSED on every page load
       (overrides "remember last state" per user direction).
     - No vehicle → restore last toggle from sessionStorage('ymmMobileCollapsed'),
       defaulting to EXPANDED on first visit.
     - SHOP tapped → force COLLAPSED.
     - × Clear → fire garage:clear, return to default EXPANDED.
   ============================================================ */
(function () {
  'use strict';

  var MOBILE_MQ = window.matchMedia('(max-width: 1024px)');
  var SS_KEY = 'ymmMobileCollapsed';
  var BAR_ID = 'ymm-mobile-bar';
  var initialized = false;
  var bar = null;

  function getCmVehicle() {
    if (window.Convermax && typeof window.Convermax.getVehicle === 'function') {
      try {
        var v = window.Convermax.getVehicle();
        if (v && v.Year && v.Make && v.Model) return v;
      } catch (_) {}
    }
    return null;
  }

  // Convermax's own 1-second sync writes localStorage.ymm-{year,make,model}
  // only when the active vehicle is "complete" — for makes/models that have
  // Submodel options in Convermax's data (e.g. Cadillac Escalade), an empty
  // Submodel skips the write. The PDP gate banner in product-fitment-banner.js
  // reads strictly from these localStorage keys, so without a mirror the
  // banner shows "Enter your vehicle" while the YMM bar (which falls back to
  // Convermax.getVehicle()) correctly shows the vehicle. Submodel is hidden
  // on mobile per Notion #401, so this mismatch is the common case there.
  //
  // Gate on sessionStorage.ymmUserCleared so the mirror doesn't fight a CLEAR
  // the user just made. clearVehicle() sets the flag; the next user-driven
  // SHOP / ymmUpdated drops it.
  function mirrorConvermaxToLocalStorage() {
    try {
      if (sessionStorage.getItem('ymmUserCleared') === '1') return false;
    } catch (_) {}
    var y = localStorage.getItem('ymm-year');
    var m = localStorage.getItem('ymm-make');
    var d = localStorage.getItem('ymm-model');
    if (y && m && d) return false;
    var cm = getCmVehicle();
    if (!cm) return false;
    try {
      localStorage.setItem('ymm-year', String(cm.Year));
      localStorage.setItem('ymm-make', String(cm.Make));
      localStorage.setItem('ymm-model', String(cm.Model));
    } catch (_) { return false; }
    try {
      window.dispatchEvent(new CustomEvent('ymmUpdated', {
        detail: { year: String(cm.Year), make: String(cm.Make), model: String(cm.Model) }
      }));
    } catch (_) {}
    return true;
  }

  function isVehicleSet() {
    var y = localStorage.getItem('ymm-year');
    var m = localStorage.getItem('ymm-make');
    var d = localStorage.getItem('ymm-model');
    if (y && m && d) return true;
    // After × Clear on PDP we keep Convermax's in-memory state (we don't call
    // clearCurrentRequest because it always navigates). Honor the same sticky
    // flag here so the bar label resets to "Shop By Vehicle" instead of
    // resurrecting from Convermax.getVehicle() until the user picks again.
    try {
      if (sessionStorage.getItem('ymmUserCleared') === '1') return false;
    } catch (_) {}
    if (getCmVehicle()) {
      mirrorConvermaxToLocalStorage();
      return true;
    }
    return false;
  }

  function getVehicleLabel() {
    var y = localStorage.getItem('ymm-year');
    var m = localStorage.getItem('ymm-make');
    var d = localStorage.getItem('ymm-model');
    if (y && m && d) return [y, m, d].join(' ').trim();
    if (window.Convermax && typeof window.Convermax.getVehicleString === 'function') {
      try {
        var s = window.Convermax.getVehicleString();
        if (s) return s;
      } catch (_) {}
    }
    var cm = getCmVehicle();
    return cm ? [cm.Year, cm.Make, cm.Model].join(' ').trim() : '';
  }

  function shouldStartCollapsed() {
    if (isVehicleSet()) return true;
    return sessionStorage.getItem(SS_KEY) === '1';
  }

  function setBodyState(collapsed) {
    document.body.classList.toggle('ymm-mobile-collapsed', !!collapsed);
    document.body.classList.toggle('ymm-mobile-expanded', !collapsed);
  }

  function persistState(collapsed) {
    try { sessionStorage.setItem(SS_KEY, collapsed ? '1' : '0'); } catch (_) {}
  }

  function buildBar() {
    if (document.getElementById(BAR_ID)) return document.getElementById(BAR_ID);
    var el = document.createElement('div');
    el.id = BAR_ID;
    el.className = 'ymm-mobile-bar';
    el.setAttribute('role', 'button');
    el.setAttribute('tabindex', '0');
    el.setAttribute('aria-expanded', 'false');
    el.innerHTML =
      '<svg class="ymm-mobile-bar__icon" viewBox="0 0 24 24" aria-hidden="true">' +
        '<path d="M5 11h14l-1.5-4.5A2 2 0 0 0 15.6 5H8.4a2 2 0 0 0-1.9 1.5L5 11zm14 2H5v4a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1h8v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-4zM7.5 16a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm9 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>' +
      '</svg>' +
      '<span class="ymm-mobile-bar__label">Shop By Vehicle</span>' +
      '<a class="ymm-mobile-bar__clear" href="#" aria-label="Clear vehicle" style="display:none">× Clear</a>' +
      '<svg class="ymm-mobile-bar__chevron" viewBox="0 0 24 24" aria-hidden="true">' +
        '<path d="M7 10l5 5 5-5z" stroke="currentColor" stroke-width="0.5"/>' +
      '</svg>';
    return el;
  }

  function refreshBar() {
    if (!bar) return;
    var label = bar.querySelector('.ymm-mobile-bar__label');
    var clear = bar.querySelector('.ymm-mobile-bar__clear');
    var newText = isVehicleSet() ? getVehicleLabel() : 'Shop By Vehicle';
    var newTransform = isVehicleSet() ? 'none' : 'uppercase';
    var newLetterSp = isVehicleSet() ? '0' : '0.5px';
    var newClearDisp = isVehicleSet() ? '' : 'none';
    var newAria = String(!document.body.classList.contains('ymm-mobile-collapsed'));
    if (label.textContent !== newText) label.textContent = newText;
    if (label.style.textTransform !== newTransform) label.style.textTransform = newTransform;
    if (label.style.letterSpacing !== newLetterSp) label.style.letterSpacing = newLetterSp;
    if (clear.style.display !== newClearDisp) clear.style.display = newClearDisp;
    if (bar.getAttribute('aria-expanded') !== newAria) bar.setAttribute('aria-expanded', newAria);
  }

  function expand() { setBodyState(false); persistState(false); refreshBar(); }
  function collapse() { setBodyState(true); persistState(true); refreshBar(); }
  function toggle() {
    if (document.body.classList.contains('ymm-mobile-collapsed')) expand();
    else collapse();
  }

  function clearVehicle(e) {
    if (e) { e.preventDefault(); e.stopPropagation(); }
    try { localStorage.removeItem('ymm-year'); } catch (_) {}
    try { localStorage.removeItem('ymm-make'); } catch (_) {}
    try { localStorage.removeItem('ymm-model'); } catch (_) {}
    // Also scrub Convermax's own caches so the mirror in mirrorConvermaxToLocalStorage()
    // (and the banner's getVehicleFromConvermaxSources fallback) can't resurface the
    // just-cleared vehicle from cm_variant-model / cm_variant-garage / Convermax.getVehicle().
    try { localStorage.removeItem('cm_variant-model'); } catch (_) {}
    try { localStorage.removeItem('cm_variant-garage'); } catch (_) {}
    try { sessionStorage.removeItem('cm_vehicle'); } catch (_) {}
    // Sticky flag prevents the mirror from rewriting localStorage from Convermax's
    // in-memory state during the brief window before clearCurrentRequest(false)
    // tears Convermax down. Cleared on next ymmUpdated (= user picked a new vehicle).
    try { sessionStorage.setItem('ymmUserCleared', '1'); } catch (_) {}
    window.dispatchEvent(new CustomEvent('garage:clear'));
    window.dispatchEvent(new CustomEvent('fitment:refresh'));
    expand();
    // Reset the global Convermax YMM dropdowns (Year/Make/Model/Submodel) to
    // their empty placeholder so the bar's expanded form reflects the cleared
    // state. We can't call clearCurrentRequest on PDP (always navigates), and
    // localStorage scrub alone doesn't visually reset the <select>s — Convermax's
    // in-memory state still drives their displayed value.
    try {
      var resetWidgetDropdowns = function () {
        ['Year', 'Make', 'Model', 'Submodel'].forEach(function (label) {
          var el = Array.from(document.querySelectorAll('.cm_vehicle-widget .cm_select_inner-select[aria-label="' + label + '"]'))
            .find(function (s) { return !s.closest('#cm-verify-fitment'); });
          if (!el) return;
          if (el.value !== '') {
            el.value = '';
            el.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      };
      resetWidgetDropdowns();
    } catch (_) {}
    // On PDP, skip Convermax.clearCurrentRequest(false) entirely — it always
    // navigates to /pages/search (no non-navigating alternative exists), and
    // dumping the customer to a search page when they just want to swap
    // vehicles on this product is the wrong UX. Bar UI + banner are already
    // updated above; cm-verify-fitment is hidden by product-fitment-banner.js
    // so any stale Convermax in-memory state doesn't leak visually. As
    // defense-in-depth on Chromium browsers, mark a bar-clear timestamp so
    // the Navigation API interceptor cancels any navigation that does sneak
    // through.
    try { window.__ymmBarClearedAt = Date.now(); } catch (_) {}
    var onProductPage = document.body && document.body.classList && document.body.classList.contains('template-product');
    if (onProductPage) return;
    if (window.Convermax && typeof window.Convermax.clearCurrentRequest === 'function') {
      try { window.Convermax.clearCurrentRequest(false); } catch (_) {}
    }
  }

  function mountBar() {
    if (bar && document.body.contains(bar)) return;
    var ymm = document.getElementById('cm-ymm');
    if (!ymm || !ymm.parentNode) return;
    bar = buildBar();
    ymm.parentNode.insertBefore(bar, ymm);
    bar.addEventListener('click', function (e) {
      if (e.target.closest('.ymm-mobile-bar__clear')) return;
      toggle();
    });
    bar.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
    });
    var clearLink = bar.querySelector('.ymm-mobile-bar__clear');
    if (clearLink) clearLink.addEventListener('click', clearVehicle);
  }

  function unmountBar() {
    if (bar && bar.parentNode) bar.parentNode.removeChild(bar);
    bar = null;
    document.body.classList.remove('ymm-mobile-collapsed', 'ymm-mobile-expanded');
  }

  var initialStateApplied = false;

  function applyInitialState() {
    setBodyState(shouldStartCollapsed());
    refreshBar();
    initialStateApplied = true;
  }

  function reapplyOnRemount() {
    refreshBar();
  }

  // PDP Improvements #13: the observer below outlived teardown() and re-mounted the bar after a
  // resize back to desktop, where the bar has no styles (its car icon rendered 1440px wide), and
  // every return to mobile bound a second set of listeners. Bind once; observe only while mobile.
  var mo = null;

  function init() {
    if (initialized) return;
    if (!MOBILE_MQ.matches) return;
    initialized = true;

    var attempts = 0;
    var poll = setInterval(function () {
      attempts++;
      if (document.getElementById('cm-ymm')) {
        clearInterval(poll);
        mountBar();
        applyInitialState();
      } else if (attempts > 60) {
        clearInterval(poll);
      }
    }, 100);

    if (mo) {
      // Back to mobile after a resize: listeners are already bound, just resume observing.
      mo.observe(document.body, { childList: true, subtree: true });
      return;
    }

    var moScheduled = false;
    mo = new MutationObserver(function () {
      if (moScheduled) return;
      moScheduled = true;
      requestAnimationFrame(function () {
        moScheduled = false;
        if (!initialized) return;
        if (!document.getElementById('cm-ymm')) return;
        if (!bar || !document.body.contains(bar)) {
          mountBar();
          if (!initialStateApplied) applyInitialState();
          else reapplyOnRemount();
        } else {
          refreshBar();
        }
      });
    });
    mo.observe(document.body, { childList: true, subtree: true });

    window.addEventListener('ymm:filter', function () {
      if (!initialized) return;
      setTimeout(function () { collapse(); }, 50);
    });
    document.addEventListener('click', function (e) {
      if (!MOBILE_MQ.matches) return;
      if (!e.target.closest('.cm_vehicle-widget_button__go')) return;
      // Clicking SHOP is a positive vehicle commit, so drop any sticky
      // "user cleared" flag. Without this, after a prior × Clear the flag
      // stays set, isVehicleSet() short-circuits to false, and the collapsed
      // bar keeps showing "Shop By Vehicle" with the × Clear hidden even
      // though Convermax now has an active vehicle. #401 fix (parity w/ 4Play).
      try { sessionStorage.removeItem('ymmUserCleared'); } catch (_) {}
      setTimeout(function () { collapse(); }, 100);
    });
    window.addEventListener('garage:clear', function () {
      setTimeout(refreshBar, 50);
    });
    window.addEventListener('fitment:refresh', refreshBar);
    // A genuine vehicle pick (Y/M/M present in detail) drops the just-cleared
    // sticky flag so mirrorConvermaxToLocalStorage can run again on subsequent
    // routes. Also resync the label.
    window.addEventListener('ymmUpdated', function (e) {
      if (e && e.detail && e.detail.year && e.detail.make && e.detail.model) {
        try { sessionStorage.removeItem('ymmUserCleared'); } catch (_) {}
      }
      refreshBar();
    });
    window.addEventListener('storage', function (e) {
      if (e.key && e.key.indexOf('ymm-') === 0) refreshBar();
    });
  }

  function teardown() {
    if (!initialized) return;
    initialized = false;
    if (mo) mo.disconnect();
    unmountBar();
  }

  if (typeof MOBILE_MQ.addEventListener === 'function') {
    MOBILE_MQ.addEventListener('change', function (e) {
      if (e.matches) init();
      else teardown();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ---------------------------------------------------------------------------
 * Notion #429 — reconcile localStorage ymm-* with Convermax on page load
 *
 * The top fitment ribbon (product-fitment-banner.js) and the disclaimer above
 * Add to Cart (product-form.js) both treat localStorage ymm-year/make/model as
 * authoritative and deliberately do NOT fall back to Convermax while those keys
 * are populated. But the homepage / global YMM widget only sets Convermax state
 * and navigates — it never writes ymm-*. Results:
 *
 *   - ymm-* empty (vehicle only ever set from the homepage)
 *       -> ribbon shows "Enter your vehicle" while the bar and the disclaimer
 *          are correct.                                        (#429 bug 2)
 *   - ymm-* stale (a PDP change wrote it, then the shopper changed vehicle on
 *     the homepage)
 *       -> ribbon AND disclaimer both show the previous vehicle. (#429 bug 1)
 *
 * mirrorConvermaxToLocalStorage() above was meant to cover this but (a) only
 * backfills when the keys are empty, so it never corrects a stale vehicle, and
 * (b) lives inside the mobile YMM bar IIFE, which returns early above 1024px —
 * so on desktop it never runs at all.
 *
 * This block runs on every viewport. It is a ONE-SHOT at page load, on purpose:
 * the PDP "Enter your vehicle" modal writes ymm-* immediately but syncs the
 * Convermax widget through staggered 600ms + 600ms change events, so for ~1.2s
 * ymm-* is newer than Convermax. A continuously-running reconcile would read
 * Convermax's older value during that window and revert the shopper's pick.
 * We therefore reconcile once, as soon as Convermax first reports a vehicle,
 * and stand down permanently on any user-driven ymmUpdated.
 *
 * Never clears ymm-*: if Convermax has no vehicle we do nothing. Clearing stays
 * the job of clearVehicle(), which is also why the ymmUserCleared guard is kept.
 * ------------------------------------------------------------------------- */
(function () {
  var TICK_MS = 300;
  var MAX_WAIT_MS = 20000;
  var SOURCE = 'ymm-reconcile-429';

  var stopped = false;
  var waited = 0;
  var timer = null;

  function stop() {
    stopped = true;
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  }

  // Any genuine vehicle pick (modal, widget, PDP-stay intercept) means the page
  // state is now user-driven and must not be second-guessed.
  window.addEventListener('ymmUpdated', function (e) {
    if (e && e.detail && e.detail.source === SOURCE) return;
    stop();
  });

  function convermaxVehicle() {
    try {
      if (window.Convermax && typeof window.Convermax.getVehicle === 'function') {
        var v = window.Convermax.getVehicle();
        if (v && v.Year && v.Make && v.Model) return v;
      }
    } catch (_) {}
    return null;
  }

  function reconcile() {
    if (stopped) return;

    try {
      if (sessionStorage.getItem('ymmUserCleared') === '1') { stop(); return; }
    } catch (_) {}

    var cm = convermaxVehicle();
    if (!cm) return; // Convermax not ready yet (or genuinely no vehicle) — keep waiting

    var year = String(cm.Year);
    var make = String(cm.Make);
    var model = String(cm.Model);

    var y, m, d;
    try {
      y = localStorage.getItem('ymm-year');
      m = localStorage.getItem('ymm-make');
      d = localStorage.getItem('ymm-model');
    } catch (_) { stop(); return; }

    // Convermax has answered, so this was our one shot either way.
    stop();

    if (y === year && m === make && d === model) return; // already in sync

    try {
      localStorage.setItem('ymm-year', year);
      localStorage.setItem('ymm-make', make);
      localStorage.setItem('ymm-model', model);
    } catch (_) { return; }

    // Repaint the ribbon (listens to both) and the disclaimer.
    try {
      window.dispatchEvent(new CustomEvent('ymmUpdated', {
        detail: { year: year, make: make, model: model, source: SOURCE }
      }));
    } catch (_) {}
    try {
      window.dispatchEvent(new CustomEvent('fitment:refresh'));
    } catch (_) {}
  }

  function start() {
    reconcile();
    if (stopped) return;
    timer = setInterval(function () {
      waited += TICK_MS;
      if (waited >= MAX_WAIT_MS) { stop(); return; }
      reconcile();
    }, TICK_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
